import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'content'
})``;

export const FormActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  gap: 20px;

  button {
    width: 100%;
  }

  a {
    color: #CB3D42;
    font-size: 12px;
    font-weight: 400;
    margin-right: 24px;
  }
`

export const SectionRegister = styled.div`
  width: 75%;
  margin: 0 auto;
  
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-height: 768px) {
      margin-top: 24px;
  }

  p {
    margin-top: 0;
    margin-bottom: 10px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    font-weight: 500;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 12px;
    font-weight: 500;
    padding: 6px 12px;
  }
`
